import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ITServices.css';

function ITServices() {
  useEffect(() => {
    // Services scroll functionality
    const svcTrack = document.getElementById('svcTrack');
    const svcPrev = document.getElementById('svcPrev');
    const svcNext = document.getElementById('svcNext');
    const svcBar = document.getElementById('svcBar');
    const svcCurrent = document.getElementById('svcCurrent');
    
    if (!svcTrack || !svcPrev || !svcNext || !svcBar || !svcCurrent) return;
    
    let currentIndex = 0;
    const totalCards = 9;
    const cardWidth = 374; // 350px + 24px gap
    
    function updateScroll() {
      const scrollPosition = currentIndex * cardWidth;
      svcTrack.style.transform = `translateX(-${scrollPosition}px)`;
      
      // Update progress bar
      const progress = ((currentIndex + 1) / totalCards) * 100;
      svcBar.style.width = `${progress}%`;
      
      // Update counter
      const displayIndex = currentIndex + 1;
      svcCurrent.textContent = displayIndex.toString().padStart(2, '0');
      
      // Update active card
      const cards = svcTrack.querySelectorAll('.svc-card');
      cards.forEach((card, index) => {
        card.classList.toggle('active', index === currentIndex);
      });
    }
    
    svcPrev.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateScroll();
      }
    });
    
    svcNext.addEventListener('click', () => {
      if (currentIndex < totalCards - 1) {
        currentIndex++;
        updateScroll();
      }
    });
    
    // Reveal animation for services
    const revealElements = document.querySelectorAll('.reveal');
    const revealOnScroll = () => {
      revealElements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (elementTop < windowHeight * 0.8) {
          element.classList.add('reveal');
        }
      });
    };
    
    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll(); // Initial check
    
    return () => {
      window.removeEventListener('scroll', revealOnScroll);
    };
  }, []);

  return (
    <div className="it-services-page">
      <section className="hero-it-serv">
        <div className="hero-blob blob1"></div>
        <div className="hero-blob blob2"></div>
        <div className="hero-left">
          <div className="hero-eyebrow">Chennai, India · Est. 2019</div>
          <h1 className="hero-h1">
            <span className="stroke">WE BUILD</span><br />
            <span className="fill-g">DIGITAL</span><br />
            <span>FUTURE</span>
          </h1>
          <p className="hero-desc">End-to-end technology solutions from concept to deployment. We turn your vision into reality with cutting-edge development and design.</p>
          <div className="hero-metrics">
            <div className="metric"><div className="val">50<sup>+</sup></div><div className="key">Projects</div></div>
            <div className="metric"><div className="val">40<sup>+</sup></div><div className="key">Clients</div></div>
            <div className="metric"><div className="val">5<sup>+</sup></div><div className="key">Yrs Exp</div></div>
          </div>
        </div>
        <div className="hero-right">
          <div className="bl-vis">
            <div className="v-chip-grid">
              <div className="v-chip"><div className="v-chip-icon">React</div><div className="v-chip-name">Frontend Development</div><div className="v-chip-sub">React · Vue.js · Angular · Next.js</div></div>
              <div className="v-chip"><div className="v-chip-icon">Node.js</div><div className="v-chip-name">Backend Development</div><div className="v-chip-sub">Node.js · Python · Java · .NET</div></div>
              <div className="v-chip"><div className="v-chip-icon">Mobile</div><div className="v-chip-name">Mobile Development</div><div className="v-chip-sub">React Native · Flutter · Swift · Kotlin</div></div>
              <div className="v-chip"><div className="v-chip-icon">Cloud</div><div className="v-chip-name">Cloud & DevOps</div><div className="v-chip-sub">AWS · Azure · GCP · Docker</div></div>
              <div className="v-chip"><div className="v-chip-icon">Database</div><div className="v-chip-name">Database Solutions</div><div className="v-chip-sub">PostgreSQL · MongoDB · Redis · MySQL</div></div>
              <div className="v-chip"><div className="v-chip-icon">DevOps</div><div className="v-chip-name">DevOps & CI/CD</div><div className="v-chip-sub">Kubernetes · Jenkins · GitLab · Terraform</div></div>
            </div>
          </div>
        </div>
      </section>

      <div className="marquee-bar">
        <div className="marquee-track">
          <span>App Development</span>
          <span>Web Development</span>
          <span>UI/UX Design</span>
          <span>Cloud Solutions</span>
          <span>AI Integration</span>
          <span>Mobile Apps</span>
          <span>Enterprise Software</span>
          <span>DevOps</span>
          <span>Cybersecurity</span>
          <span>Data Analytics</span>
          <span>App Development</span>
          <span>Web Development</span>
          <span>UI/UX Design</span>
          <span>Cloud Solutions</span>
          <span>AI Integration</span>
          <span>Mobile Apps</span>
          <span>Enterprise Software</span>
          <span>DevOps</span>
          <span>Cybersecurity</span>
          <span>Data Analytics</span>
        </div>
      </div>

      <section id="services">
        <div className="svc-header reveal">
          <div>
            <span className="svc-tag-IT">01 — What We Build</span>
            <h2 className="svc-title">OUR<br /><span className="stroke">SERVICES</span></h2>
          </div>
          <div className="svc-count">09 CAPABILITIES</div>
        </div>
        <div className="svc-scroll-wrap">
          <div className="svc-scroll-track" id="svcTrack">
            <div className="svc-card active">
              <div className="svc-card-num">01</div>
              <div><div className="svc-card-icon">📱</div><h3>Mobile App Development</h3><p>Native and cross-platform apps for iOS & Android. From sleek consumer apps to complex enterprise mobile solutions — performance and UX, uncompromised.</p></div>
              <div className="svc-techs"><span className="svc-tech">React Native</span><span className="svc-tech">Flutter</span><span className="svc-tech">Swift</span><span className="svc-tech">Kotlin</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">02</div>
              <div><div className="svc-card-icon">🌐</div><h3>Web Development</h3><p>Scalable web applications and platforms built with modern stacks. From marketing sites to large-scale SaaS portals — responsive, fast, conversion-optimised.</p></div>
              <div className="svc-techs"><span className="svc-tech">React</span><span className="svc-tech">Next.js</span><span className="svc-tech">Node.js</span><span className="svc-tech">Django</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">03</div>
              <div><div className="svc-card-icon">🎨</div><h3>UI/UX Design</h3><p>User-centric design that balances aesthetics with usability. Wireframes, prototypes, and full UI systems that delight users and drive business goals.</p></div>
              <div className="svc-techs"><span className="svc-tech">Figma</span><span className="svc-tech">Sketch</span><span className="svc-tech">Adobe XD</span><span className="svc-tech">Prototyping</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">04</div>
              <div><div className="svc-card-icon">☁️</div><h3>Cloud & DevOps</h3><p>End-to-end cloud architecture and DevOps pipelines. From migration to optimisation, we ensure scalability, security, and continuous delivery.</p></div>
              <div className="svc-techs"><span className="svc-tech">AWS</span><span className="svc-tech">GCP</span><span className="svc-tech">Docker</span><span className="svc-tech">Kubernetes</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">05</div>
              <div><div className="svc-card-icon">🤖</div><h3>AI & Automation</h3><p>Intelligent automation and AI integration. From chatbots to predictive analytics, we embed AI that adds real value to your operations.</p></div>
              <div className="svc-techs"><span className="svc-tech">OpenAI</span><span className="svc-tech">TensorFlow</span><span className="svc-tech">Python</span><span className="svc-tech">ML Pipelines</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">06</div>
              <div><div className="svc-card-icon">🏢</div><h3>ERP & Enterprise IT</h3><p>Custom ERP solutions and enterprise system integration. Streamline operations with tailored software that scales with your business.</p></div>
              <div className="svc-techs"><span className="svc-tech">SAP</span><span className="svc-tech">Oracle</span><span className="svc-tech">Custom ERP</span><span className="svc-tech">Integration</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">07</div>
              <div><div className="svc-card-icon">🔒</div><h3>Cybersecurity</h3><p>Comprehensive security assessments and solutions. From penetration testing to compliance audits, we protect your digital assets.</p></div>
              <div className="svc-techs"><span className="svc-tech">VAPT</span><span className="svc-tech">SIEM</span><span className="svc-tech">Compliance</span><span className="svc-tech">Security Audits</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">08</div>
              <div><div className="svc-card-icon">🛠️</div><h3>IT Consulting</h3><p>Strategic technology consulting and roadmap planning. We help you make the right technology decisions that align with your business goals.</p></div>
              <div className="svc-techs"><span className="svc-tech">Strategy</span><span className="svc-tech">Architecture</span><span className="svc-tech">Roadmap</span><span className="svc-tech">Digital Transformation</span></div>
            </div>
            <div className="svc-card">
              <div className="svc-card-num">09</div>
              <div><div className="svc-card-icon">🧪</div><h3>QA & Testing</h3><p>Rigorous quality assurance and testing services. From unit tests to performance testing, we ensure your software works flawlessly.</p></div>
              <div className="svc-techs"><span className="svc-tech">Selenium</span><span className="svc-tech">Cypress</span><span className="svc-tech">Load Testing</span><span className="svc-tech">Automation</span></div>
            </div>
          </div>
        </div>
        <div className="svc-nav reveal">
          <button className="svc-arrow" id="svcPrev">←</button>
          <button className="svc-arrow" id="svcNext">→</button>
          <div className="svc-progress"><div className="svc-progress-bar" id="svcBar" style={{width: '11%'}}></div></div>
          <div className="svc-counter"><span id="svcCurrent">01</span> / 09</div>
        </div>
      </section>

      <section id="process" className="reveal">
        <div className="process-header">
          <span className="svc-tag-IT">02 — How We Work</span>
          <h2 className="svc-title">THE<br /><span className="stroke">PROCESS</span></h2>
        </div>
        <div className="proc-steps">
          <div className="proc-line"></div>
          <div className="proc-step">
            <div className="proc-dot">01</div>
            <div className="proc-body"><span className="proc-tag">Week 1</span><h4>Discovery & Scoping</h4><p>We start by understanding your goals, users and constraints. Stakeholder workshops, competitor analysis and a detailed brief set foundation for everything that follows.</p></div>
          </div>
          <div className="proc-step">
            <div className="proc-dot">02</div>
            <div className="proc-body"><span className="proc-tag">Week 2–3</span><h4>Design & Architecture</h4><p>Wireframes, UI mockups and technical architecture reviewed together — so you see and approve exactly what we'll build before a single line of code is written.</p></div>
          </div>
          <div className="proc-step">
            <div className="proc-dot">03</div>
            <div className="proc-body"><span className="proc-tag">Ongoing Sprints</span><h4>Agile Development</h4><p>Two-week sprints with live demos, daily standups and a shared project dashboard. You're never in the dark about where your product stands.</p></div>
          </div>
          <div className="proc-step">
            <div className="proc-dot">04</div>
            <div className="proc-body"><span className="proc-tag">Pre-Launch</span><h4>Testing & QA</h4><p>Comprehensive test cycles covering functional, performance and security dimensions. We don't ship until it passes our rigorous quality bar.</p></div>
          </div>
          <div className="proc-step">
            <div className="proc-dot">05</div>
            <div className="proc-body"><span className="proc-tag">Post-Launch</span><h4>Deploy & Scale</h4><p>Smooth production deployment with real-time monitoring, SLA-backed support and a dedicated team ready to iterate fast as your product grows.</p></div>
          </div>
        </div>
      </section>

      <section id="why">
        <div className="why-left reveal">
          <span className="svc-tag-IT">03 — Why Krishpar</span>
          <h2 className="svc-title" style={{marginBottom: '28px'}}>BUILT<br /><span className="stroke">DIFFERENT.</span><br /><span style={{color: 'var(--g)'}}>DELIVERS.</span></h2>
          <p style={{fontSize: '15px', color: 'var(--muted)', lineHeight: '1.8', maxWidth: '380px'}}>We're not a body-shop — we're a product-thinking team that takes full ownership of outcomes, not just outputs.</p>
        </div>
        <div className="why-right reveal">
          <div className="why-block"><span className="ico">⚡</span><h5>Full-Stack Under One Roof</h5><p>Design, dev, QA and DevOps — no handoff chaos, single point of accountability.</p></div>
          <div className="why-block"><span className="ico">🌏</span><h5>Chennai-Based, Global Standards</h5><p>Local team, timezone-friendly, yet aligned with international delivery benchmarks.</p></div>
          <div className="why-block"><span className="ico">🔭</span><h5>Transparent by Default</h5><p>Live dashboards, weekly reports, direct access — you always know the status.</p></div>
          <div className="why-block"><span className="ico">🛡️</span><h5>Post-Launch Partner</h5><p>We stay engaged after go-live. Ongoing maintenance, enhancements and SLA support.</p></div>
        </div>
      </section>

      <section id="industries">
        <div className="reveal">
          <span className="svc-tag-IT">04 — Sectors We Serve</span>
          <h2 className="svc-title">INDUSTRIES<br /><span className="stroke">WE EMPOWER</span></h2>
        </div>
        <div className="ind-grid reveal">
          <div className="ind-item"><span className="icon">🏥</span><span>Healthcare & MedTech</span></div>
          <div className="ind-item"><span className="icon">🏦</span><span>Banking & Fintech</span></div>
          <div className="ind-item"><span className="icon">🛒</span><span>E-Commerce & Retail</span></div>
          <div className="ind-item"><span className="icon">🎓</span><span>EdTech & E-Learning</span></div>
          <div className="ind-item"><span className="icon">🏭</span><span>Manufacturing & ERP</span></div>
          <div className="ind-item"><span className="icon">🚚</span><span>Logistics & Supply Chain</span></div>
          <div className="ind-item"><span className="icon">🏠</span><span>Real Estate & PropTech</span></div>
          <div className="ind-item"><span className="icon">🍴</span><span>Food & Hospitality</span></div>
        </div>
      </section>

      <section id="contact">
        <div className="talk-to-us-container">
          <div className="talk-to-us-content">
            <div className="talk-to-us-label">Get Started</div>
            <h2 className="talk-to-us-title">Ready to Build Your Digital Future?</h2>
            <p className="talk-to-us-desc">
              Have a project in mind? Let's discuss how we can transform your ideas into reality with cutting-edge technology solutions.
            </p>
            <div className="talk-to-us-action">
              <Link to="/contact" className="talk-to-us-btn">Talk to Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ITServices;
